var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export var StyledTextField = function (_a) {
    var _b = _a.placeholder, placeholder = _b === void 0 ? 'Enter your comment here...' : _b, value = _a.value, onChange = _a.onChange, maxLength = _a.maxLength, rows = _a.rows, _c = _a.className, className = _c === void 0 ? '' : _c, rest = __rest(_a, ["placeholder", "value", "onChange", "maxLength", "rows", "className"]);
    return (_jsx("textarea", __assign({ placeholder: placeholder, value: value, onChange: onChange, maxLength: maxLength, rows: rows, className: "w-full p-1 !border !border-gray-300 rounded-md resize-none focus:!outline-none focus:!border-vjwPrimary text-base scrollbar-thin scrollbar-thumb-[#324ECF] scrollbar-track-white hover:scrollbar-thumb-[rgb(35,54,144)] ".concat(className), autoComplete: 'off' }, rest)));
};
